import React, { useEffect, useState } from 'react';
import _ from 'lodash';

const HospitalView = (props) => {
  const [hospitalSet, setHospitalSet] = useState([]);
  const [hospitalSetsByType, setHospitalSetsByType] = useState([]);
  const [allHospitalSets, setAllHospitalSets] = useState([]);
  const [caseTypeNew, setCaseTypeNew] = useState([]);
  // const [caseFlag, setCaseFlag] = useState(false);

  useEffect(() => {
    setAllHospitalSets(props.hospitalSets);
    setHospitalSet(props.hospitalSets);
  }, [props.hospitalSets]);

  useEffect(() => {
    _caseType();
  }, [props.caseType, props.keyType]);

  useEffect(() => {
    setHospitalSetsByType(_getHospitalSets());
  }, [hospitalSet]);

  useEffect(() => {
    setCaseTypeNew(props.caseType);
  }, [props.caseType]);

  useEffect(() => {
    _caseType();
  }, [caseTypeNew]);

  useEffect(async () => {
    const dataSetList = await _getHospitalSets();
    setHospitalSetsByType(dataSetList);
  }, [hospitalSet]);

  const _getHospitalSets = () => {
    const result = [...hospitalSet.reduce((mp, o) => {
      if (!mp.has(o.SetName)) mp.set(o.SetName, { ...o, count: 0 });
      mp.get(o.SetName).count++;
      return mp;
    }, new Map()).values()];

    const hospitalSetsRes = result.filter((obj) => obj.DeviceType !== null);
    const hospitalSetsByTypes = _.groupBy(hospitalSetsRes, 'DeviceType');
    const sorted = Object.keys(hospitalSetsByTypes)
      .sort()
      .reduce((accumulator, key) => {
        accumulator[key] = hospitalSetsByTypes[key];
        return accumulator;
      }, {});

    return sorted;
  };

  const _caseType = async () => {
    const { keyType } = props;
    const selectedCase = caseTypeNew.find((item) => item.key === keyType);
    if (selectedCase) {
      const caseData = selectedCase.type;
      // const filteredSets = allHospitalSets.filter((d) => (d.CaseType === caseData));
      const filteredSets = allHospitalSets.filter((d) => (d.CaseType.indexOf(caseData) > -1));
      setHospitalSet(caseData === 'all' ? allHospitalSets : filteredSets);
      // setCaseFlag(caseData !== 'all');
    }
  };

  // const getCaseCount = (data) => {
  //   const caseCounts = data.reduce((acc, item) => {
  //     acc[item.CaseNo] = (acc[item.CaseNo] || 0) + 1;
  //     return acc;
  //   }, {});

  //   const dataList = Object.entries(caseCounts).map(([CaseNo, count]) => ({ CaseNo, count }));

  //   return dataList.length;
  // };

  return (
    <>
      {
        Object.keys(hospitalSetsByType).map((sets) => (
          <div key={sets}>
            <h4 className="setName">
              {sets.toLowerCase()}{(hospitalSetsByType[sets]).length > 1 ? 's' : ''}
            </h4>
            <table className="table table-bordered plan-table">
              <tbody>
                {
                  hospitalSetsByType[sets].map((set, s) => (
                    <tr className={s} key={s}>
                      <td className="col-10">{set.SetName}</td>
                      <td className="col-2 text-center">{set.count}</td>
                    </tr>
                  ))
                }
                <tr className="row-no-border" key={(hospitalSetsByType[sets].length)}>
                  <td className="col-10" />
                  <td className="col-2 text-center">
                    {/* {
                      caseFlag
                        ? getCaseCount(hospitalSetsByType[sets])
                        : hospitalSetsByType[sets].reduce(
                          (total, currentValue) => (total + +currentValue.count), 0
                        )
                    } */}
                    {
                      hospitalSetsByType[sets].reduce(
                        (total, currentValue) => (total + +currentValue.count), 0
                      )
                    }
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ))
      }
    </>
  );
};

export default HospitalView;
